window.addEventListener('scroll', () => {
    const quotes = document.querySelectorAll('.c-quote');
    for (let i = 0; i < quotes.length; i += 1) {
        const position = quotes[i].getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
            quotes[i].classList.add('show');
        }
    }
});
